import { commonFetch } from './commonFetch';
import type { ApiResponseType, IRequestOptions } from './types';

export async function get<
  IResponseData = undefined,
  IRequestParams = undefined
>({
  url,
  params,
  options = {},
  baseUrl,
  responseType,
}: {
  url: string;
  params?: IRequestParams;
  options?: IRequestOptions;
  baseUrl?: string;
  responseType?: Exclude<ApiResponseType, 'raw'>;
}) {
  return commonFetch<IResponseData, IRequestParams>({
    url,
    params,
    options: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
    baseUrl,
    responseType,
  });
}

export async function post<IResponseData = unknown, IRequestParams = unknown>({
  url,
  data,
  options = {},
  baseUrl,
  responseType,
}: {
  url: string;
  data: IRequestParams;
  options?: IRequestOptions;
  baseUrl?: string;
  responseType?: ApiResponseType;
}) {
  return commonFetch<IResponseData, IRequestParams>({
    url,
    params: data,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
    baseUrl,
    responseType,
  });
}

export async function remove<
  IResponseData = unknown,
  IRequestParams = unknown
>({
  url,
  options = {},
  data,
  baseUrl,
}: {
  url: string;
  params?: IRequestParams;
  options?: IRequestOptions;
  data?: IRequestParams;
  baseUrl?: string;
}) {
  return commonFetch<IResponseData, IRequestParams>({
    url,
    params: data,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
    baseUrl,
  });
}

export async function update<
  IResponseData = unknown,
  IRequestParams = unknown
>({
  url,
  data,
  options = {},
  baseUrl,
}: {
  url: string;
  data: IRequestParams;
  options?: IRequestOptions;
  baseUrl?: string;
}) {
  return commonFetch<IResponseData, IRequestParams>({
    url,
    params: data,
    options: {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
    baseUrl,
  });
}
